import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IShippingCreateRequest } from "../models/Shipping";


export default function useShippingBulk() {
  const { get, post, postRaw, del } = useApiHelper();
  const queryClient = useQueryClient();
  const bulkShipping = useMutation(
    (partIds: string[]) => post(`/shipping/bulkship`, partIds),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable"]);
      }
    }
  );

  const shippingLabels = useMutation(
    (req: IShippingCreateRequest[]) => postRaw(`/shipping/bulk`, { shipments: req }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["parts"]);
      },
    }
  );

  return {
    bulkShipping,
    shippingLabels
  };
}
